<template>
  <van-form validate-first>
    <van-cell-group class="login__wrapper">
      <van-field
        v-model="mobile"
        clearable
        label="手机号"
        maxlength="11"
        type="tel"
        :rules="[{ pattern: /^1[3-9]\d{9}$/, message: '请输入正确的手机号' }]"
        placeholder="请输入手机号码"
      />
      <van-field
        v-model="verify_code"
        center
        clearable
        label="短信验证码"
        placeholder="请输入短信验证码"
      >
        <van-button
          :disabled="disabled"
          slot="button"
          size="small"
          type="primary"
          color="#f25c62"
          @click="getCode"
          >{{ textLoading }}</van-button
        >
      </van-field>
      <div class="login__btn_container">
        <van-button
          round
          class="login__btn"
          @click="loginHandler"
          :loading="loading"
          loading-text="登录中..."
          >登录</van-button
        >
      </div>
    </van-cell-group>
  </van-form>
</template>

<script>
import { Field, CellGroup, Form } from 'vant'

export default {
  name: 'loginMain',
  components: {
    [Field.name]: Field,
    [CellGroup.name]: CellGroup,
    [Form.name]: Form
  },
  data() {
    return {
      mobile: null,
      verify_code: null,
      loading: false,
      disabled: false,
      textLoading: '获取验证码',
      timecount: 60
    }
  },
  methods: {
    async loginHandler() {
      if (this.loading) return
      if (!this.mobile || !this.verify_code) {
        this.$toast('请完善账户信息')
        return
      }

      this.loading = true

      const { data } = await this.$store.dispatch('login', {
        mobile: this.mobile,
        verify_code: this.verify_code
      })

      this.loading = false

      if (data.err === 0) {
        this.$toast({
          duration: 800,
          message: '登录成功',
          onOpened: () => {
            this.$emit('loginSuccess')
          }
        })
      }
    },
    async getCode() {
      if (!this.mobile) {
        this.$toast('请输入手机号码')
        return
      }
      if (this.disabled) return

      this.textLoading = '验证码获取中……'

      const { data } = await this.$api.user.sendMobileVerify(this.mobile)
      if (data.err === 0) {
        this.$toast('验证码获取成功')
        this.codeLoading()
      } else {
        this.textLoading = '获取验证码'
      }
    },
    codeLoading() {
      this.disabled = true

      this.timer = setInterval(() => {
        if (this.timecount <= 0) {
          clearInterval(this.timer)

          this.disabled = false
          this.timecount = 0
          this.textLoading = '获取验证码'

          return
        }

        this.textLoading = `重新获取(${this.timecount}s)`
        this.timecount--
      }, 1000)
    }
  }
}
</script>

<style lang="less" scoped>
.login__btn_container {
  padding: 20px;
}
.login__btn {
  display: block;
  margin: 0 auto;
  box-shadow: none;
  width: 100%;
}
.login__wrapper::after {
  display: none;
}
</style>
